import { httpV2 } from "@/api";

/**
 * Obtém todas as configurações de componentes de frequência de uma empresa.
 * @param {array} model Ids dos elementos de monitoração.
 */
const GetTrendFrequencyConfigurations = function(model)
{
	return httpV2.post("/CompaniesFrequencyTrendConfigurations/CommonConfigurations", model);
};

/**
 * Obtém todas as configurações de componentes de frequência de uma empresa.
 * @param {array} model Ids dos elementos de monitoração.
 */
const GetTrendSignals = function(model)
{
	return httpV2.post("/SignalSettings", model);
};

/**
 * Insere um novo componente de frequência.
 * @param {object} model Modelo com as configurações do componente de frequência.
 */
const Create = function(model)
{
	return httpV2.post("/CompaniesFrequencyTrendConfigurations", model);
};

/**
 * Remove um ou mais componentes de frequência. 
 * @param {array} model Ids dos espectros de sinal a serem removidos.
 */
const Delete = function(model)
{
	return httpV2.delete("/CompaniesFrequencyTrendConfigurations", { data: model });
};

/**
 * Solicita logs de auditoria de tendência de frequência.
 * @param {number} companyId Id da empresa.
 * @returns {array} Lista de logs de auditoria de tendência de frequência.
 */
const GetAuditFreqTrendConfigs = function(companyId)
{
	return httpV2.get(`/AuditLoggingsFrequencyTrendsConfigurations/${companyId}`);
};

/**
 * Obtém todas as configurações de componentes de frequência de uma empresa.
 * @param {number} companyId Id da empresa.
 * @returns {array} Lista de todas configurações de componentes de frequência de uma empresa;
 */
const GetAllTrendFrequencyConfigurations = function(companyId)
{
	return httpV2.get(`/CompaniesFrequencyTrendConfigurations/${companyId}`);
};

export default
{
	GetTrendFrequencyConfigurations,
	GetAllTrendFrequencyConfigurations,
	GetAuditFreqTrendConfigs,
	GetTrendSignals,
	Create,
	Delete
};